export const results = {
  en: {
    // Common Results
    quizComplete: 'Quiz Complete!',
    congratulations: 'Congratulations!',
    score: 'Score',
    accuracy: 'Accuracy',
    time: 'Time',
    playAgain: 'Play Again',
    shareResults: 'Share Results',
    home: 'Home',
    viewAll: 'View All',
    moreAchievements: 'more achievements',
    
    // Single Player Results
    perfectScore: 'Perfect Score!',
    excellentPerformance: 'Excellent Performance!',
    excellentWork: 'Excellent Work!',
    goodJob: 'Good Job!',
    keepPracticing: 'Keep Practicing!',
    keepLearning: 'Every question is a step closer to understanding.',
    finalScore: 'Final Score',
    outOf: 'out of',
    accuracyRate: 'Accuracy Rate',
    resultsSavedSuccessfully: 'Results saved successfully',
    shareMessage: 'I scored {{score}}/{{total}} on the Bible Quiz! Can you beat my score?',
    sessionComplete: 'Session Complete',
    reflectionSubtitle: 'You spent time in God\'s Word today',
    questionsExplored: 'questions explored',
    fromCategory: 'From {{category}}',
    insightHighlight: 'Something you learned',
    comeBackTomorrow: 'Come back tomorrow',
    tomorrowPrompt: 'There\'s more to discover',
    shareWithFamily: 'Share with your family',
    continueJourney: 'Continue your journey',
    whatNext: 'What next?',
    startNextGroupTitle: 'Play another {{groupType}} quiz',
    startNextGroupSubtitle: 'Start a new round with the same {{groupType}} group, or go back to the {{groupType}} lobby.',
    waitingForNextGroupTitle: 'Waiting for the next {{groupType}} quiz',
    waitingForNextGroupSubtitle: 'The host can start another round. You can return to the {{groupType}} lobby while you wait.',
    waitForHostNextGroup: 'When the host starts another quiz, everyone will return to the room automatically.',
    startNewGroupQuiz: 'Start new {{groupType}} quiz',
    backToGroupLobby: 'Back to {{groupType}} lobby',
    daysWithScripture: 'days with Scripture this month',
    chooseNextQuiz: 'Choose Next Quiz',
    savedToJourney: 'Saved to your journey',
    storedOnDevice: 'Stored on this device',
    localGuestProgress: 'Sign in when you are ready to keep this progress across devices.',
    categoryMasterySummary: 'Your latest session has been added to {{category}}.',
    
    // Multiplayer Results
    youWon: '🏆 You Won!',
    itsATie: '🤝 It\'s a Tie!',
    gameOver: 'Game Over',
    wellPlayedBoth: 'Well played both of you!',
    betterLuckNextTime: 'Better luck next time!',
    wonTheGame: '{{name}} Won!',
    leaderboard: 'Leaderboard',
    place: 'Place',
    player: 'Player',
    rematch: 'Rematch',
    newGame: 'New Game',
    multiplayerShareMessage: 'I scored {{score}} and placed #{{place}} in a Bible Trivia match! 🏆\nJoin me next time!',
    waitingForResults: 'Waiting for results...',
    fetchingResults: 'Fetching results...',
    retryLoadResults: 'Retry',
    noPlayersFound: 'No players found in this game.',
    
    // Gamification
    xpEarned: 'Growth',
    levelUp: 'New Milestone!',
    newRank: 'New Milestone',
    achievements: 'Milestones',
    dailyStreak: 'Days with Scripture',
    daysStreak: '{{count}} days',
    viewProgress: 'View Your Journey',
    viewAchievements: 'View Milestones',
    rewardsEarned: 'Your Growth',
    earned: 'Answered',
    total: 'Total',
    toNextLevel: 'to next milestone',
    level: 'Journey',
    youAreGettingStronger: 'You are growing in knowledge',
    newAchievements: 'New Milestones',
    dayStreak: 'days with Scripture',
    days: 'days',
    best: 'Best',
    newPersonalBest: 'New personal best',
    calculatingRewards: 'Reflecting on your journey',
    retry: 'Retry',
    
    // Single Player Submitting Screen
    submittingYourResults: 'Submitting your results…',
    
    // Bible Verses
    verseFightGoodFight: '"I have fought the good fight, I have finished the race, I have kept the faith." — 2 Timothy 4:7',
    verseSpurOneAnother: '"Let us consider how to spur one another on to love and good deeds." — Hebrews 10:24',
    verseBeStrong: '"Be strong and courageous. Do not be afraid; do not be discouraged, for the Lord your God will be with you wherever you go." — Joshua 1:9',
    
    // Error Messages
    noUserAuthenticated: 'No user authenticated - cannot load gamification',
    authenticationError: 'Authentication error - cannot load gamification',
    missingQuizResults: 'Missing quiz results data',
    rewardCalculationTimeout: 'Reward calculation timed out. Please try again.',
    gamificationNotSetup: 'Gamification system not properly configured',
    failedToLoadGamification: 'Failed to load gamification data',
    shareFailed: 'Share failed',
    noRoomIdAvailable: 'No room ID available.',
    errorLoadingResults: 'Error loading results',
  },

  es: {
    // Common Results
    quizComplete: '¡Quiz Completado!',
    congratulations: '¡Felicitaciones!',
    score: 'Puntuación',
    accuracy: 'Precisión',
    time: 'Tiempo',
    playAgain: 'Jugar de Nuevo',
    shareResults: 'Compartir Resultados',
    home: 'Inicio',
    viewAll: 'Ver Todo',
    moreAchievements: 'más logros',
    
    // Single Player Results
    perfectScore: '¡Puntuación Perfecta!',
    excellentPerformance: '¡Excelente Rendimiento!',
    excellentWork: '¡Excelente Trabajo!',
    goodJob: '¡Buen Trabajo!',
    keepPracticing: '¡Sigue Practicando!',
    keepLearning: 'Cada pregunta es un paso más hacia la comprensión.',
    finalScore: 'Puntuación Final',
    outOf: 'de',
    accuracyRate: 'Tasa de Precisión',
    resultsSavedSuccessfully: 'Resultados guardados exitosamente',
    shareMessage: '¡Obtuve {{score}}/{{total}} en el Quiz Bíblico! ¿Puedes superar mi puntuación?',
    sessionComplete: 'Sesión completada',
    reflectionSubtitle: 'Hoy pasaste tiempo en la Palabra de Dios',
    questionsExplored: 'preguntas exploradas',
    fromCategory: 'De {{category}}',
    insightHighlight: 'Algo que aprendiste',
    comeBackTomorrow: 'Vuelve mañana',
    tomorrowPrompt: 'Hay más por descubrir',
    shareWithFamily: 'Compártelo con tu familia',
    continueJourney: 'Continúa tu camino',
    whatNext: '¿Qué sigue?',
    startNextGroupTitle: 'Jugar otro quiz de {{groupType}}',
    startNextGroupSubtitle: 'Inicia una nueva ronda con el mismo grupo de {{groupType}}, o vuelve a la sala de {{groupType}}.',
    waitingForNextGroupTitle: 'Esperando el siguiente quiz de {{groupType}}',
    waitingForNextGroupSubtitle: 'El anfitrión puede iniciar otra ronda. Puedes volver a la sala de {{groupType}} mientras esperas.',
    waitForHostNextGroup: 'Cuando el anfitrión inicie otro quiz, todos volverán automáticamente a la sala.',
    startNewGroupQuiz: 'Iniciar nuevo quiz de {{groupType}}',
    backToGroupLobby: 'Volver a la sala de {{groupType}}',
    daysWithScripture: 'días con la Escritura este mes',
    chooseNextQuiz: 'Elegir siguiente quiz',
    savedToJourney: 'Guardado en tu camino',
    storedOnDevice: 'Guardado en este dispositivo',
    localGuestProgress: 'Inicia sesión cuando estés listo para conservar este progreso en todos tus dispositivos.',
    categoryMasterySummary: 'Tu última sesión se agregó a {{category}}.',
    
    // Multiplayer Results
    youWon: '🏆 ¡Ganaste!',
    itsATie: '🤝 ¡Es un Empate!',
    gameOver: 'Juego Terminado',
    wellPlayedBoth: '¡Bien jugado ambos!',
    betterLuckNextTime: '¡Mejor suerte la próxima vez!',
    wonTheGame: '¡{{name}} Ganó!',
    leaderboard: 'Tabla de Posiciones',
    place: 'Lugar',
    player: 'Jugador',
    rematch: 'Revancha',
    newGame: 'Nuevo Juego',
    multiplayerShareMessage: '¡Obtuve {{score}} y quedé en el puesto #{{place}} en una partida de Trivia Bíblica! 🏆\n¡Únete la próxima vez!',
    waitingForResults: 'Esperando resultados...',
    fetchingResults: 'Obteniendo resultados...',
    retryLoadResults: 'Reintentar',
    noPlayersFound: 'No se encontraron jugadores en este juego.',
    
    // Gamification
    xpEarned: 'Crecimiento',
    levelUp: '¡Nuevo Hito!',
    newRank: 'Nuevo Hito',
    achievements: 'Hitos',
    dailyStreak: 'Dias con la Escritura',
    daysStreak: '{{count}} días',
    viewProgress: 'Ver Tu Camino',
    viewAchievements: 'Ver Hitos',
    rewardsEarned: 'Tu Crecimiento',
    earned: 'Respondidas',
    total: 'Total',
    toNextLevel: 'al siguiente hito',
    level: 'Camino',
    youAreGettingStronger: 'Estas creciendo en conocimiento',
    newAchievements: 'Nuevos Hitos',
    dayStreak: 'días con la Escritura',
    days: 'días',
    best: 'Mejor',
    newPersonalBest: 'Nuevo record personal',
    calculatingRewards: 'Reflexionando sobre tu camino',
    retry: 'Reintentar',
    
    // Single Player Submitting Screen
    submittingYourResults: 'Enviando tus resultados…',
    
    // Bible Verses
    verseFightGoodFight: '"He peleado la buena batalla, he acabado la carrera, he guardado la fe." — 2 Timoteo 4:7',
    verseSpurOneAnother: '"Considerémonos unos a otros para estimularnos al amor y a las buenas obras." — Hebreos 10:24',
    verseBeStrong: '"Esfuérzate y sé valiente; no temas ni desmayes, porque Jehová tu Dios estará contigo dondequiera que vayas." — Josué 1:9',
    
    // Error Messages
    noUserAuthenticated: 'Usuario no autenticado - no se puede cargar la gamificación',
    authenticationError: 'Error de autenticación - no se puede cargar la gamificación',
    missingQuizResults: 'Faltan datos de resultados del quiz',
    rewardCalculationTimeout: 'El cálculo de recompensas agotó el tiempo. Por favor, inténtalo de nuevo.',
    gamificationNotSetup: 'Sistema de gamificación no configurado correctamente',
    failedToLoadGamification: 'Error al cargar datos de gamificación',
    shareFailed: 'Error al compartir',
    noRoomIdAvailable: 'ID de sala no disponible.',
    errorLoadingResults: 'Error al cargar resultados',
  },

  fr: {
    savedToJourney: 'Enregistré dans votre parcours',
    backToGroupLobby: 'Retour au salon {{groupType}}',
    categoryMasterySummary: 'Votre dernière session a été ajoutée à {{category}}.',
    chooseNextQuiz: 'Choisir le prochain quiz',
    localGuestProgress: 'Connectez-vous quand vous voulez pour conserver cette progression sur tous vos appareils.',
    startNewGroupQuiz: 'Lancer un nouveau quiz {{groupType}}',
    startNextGroupSubtitle: 'Lancez une nouvelle manche avec le même groupe {{groupType}}, ou retournez au salon {{groupType}}.',
    startNextGroupTitle: 'Jouer un autre quiz {{groupType}}',
    storedOnDevice: 'Enregistré sur cet appareil',
    waitForHostNextGroup: 'Quand l\'hôte lancera un autre quiz, tout le monde reviendra automatiquement dans la salle.',
    waitingForNextGroupSubtitle: 'L\'hôte peut lancer une autre manche. Vous pouvez retourner au salon {{groupType}} en attendant.',
    waitingForNextGroupTitle: 'En attente du prochain quiz {{groupType}}',
    // Common Results
    quizComplete: 'Quiz Terminé !',
    congratulations: 'Félicitations !',
    score: 'Score',
    accuracy: 'Précision',
    time: 'Temps',
    playAgain: 'Rejouer',
    shareResults: 'Partager les Résultats',
    home: 'Accueil',
    viewAll: 'Voir Tout',
    moreAchievements: 'autres réalisations',
    
    // Single Player Results
    perfectScore: 'Score Parfait !',
    excellentPerformance: 'Excellente Performance !',
    excellentWork: 'Excellent Travail !',
    goodJob: 'Bon Travail !',
    keepPracticing: 'Continuez à Pratiquer !',
    keepLearning: 'Chaque question vous rapproche de la compréhension.',
    finalScore: 'Score Final',
    outOf: 'sur',
    accuracyRate: 'Taux de Précision',
    resultsSavedSuccessfully: 'Résultats sauvegardés avec succès',
    shareMessage: 'J\'ai obtenu {{score}}/{{total}} au Quiz Biblique ! Pouvez-vous battre mon score ?',
    sessionComplete: 'Session terminée',
    reflectionSubtitle: 'Vous avez passé du temps dans la Parole de Dieu aujourd\'hui',
    questionsExplored: 'questions explorées',
    fromCategory: 'De {{category}}',
    insightHighlight: 'Quelque chose que vous avez appris',
    comeBackTomorrow: 'Revenez demain',
    tomorrowPrompt: 'Il y a encore à découvrir',
    shareWithFamily: 'Partagez avec votre famille',
    continueJourney: 'Continuez votre parcours',
    whatNext: 'Et maintenant ?',
    daysWithScripture: 'jours avec les Écritures ce mois-ci',
    
    // Multiplayer Results
    youWon: '🏆 Vous avez Gagné !',
    itsATie: '🤝 C\'est une Égalité !',
    gameOver: 'Jeu Terminé',
    wellPlayedBoth: 'Bien joué vous deux !',
    betterLuckNextTime: 'Meilleure chance la prochaine fois !',
    wonTheGame: '{{name}} a Gagné !',
    leaderboard: 'Classement',
    place: 'Place',
    player: 'Joueur',
    rematch: 'Revanche',
    newGame: 'Nouveau Jeu',
    multiplayerShareMessage: 'J\'ai marqué {{score}} et terminé #{{place}} dans un match de Trivia Biblique ! 🏆\nRejoignez-moi la prochaine fois !',
    waitingForResults: 'En attente des résultats...',
    fetchingResults: 'Récupération des résultats...',
    retryLoadResults: 'Réessayer',
    noPlayersFound: 'Aucun joueur trouvé dans ce jeu.',
    
    // Gamification
    xpEarned: 'Croissance',
    levelUp: 'Nouveau Jalon !',
    newRank: 'Nouveau Jalon',
    achievements: 'Jalons',
    dailyStreak: 'Jours avec les Écritures',
    daysStreak: '{{count}} jours',
    viewProgress: 'Voir Votre Parcours',
    viewAchievements: 'Voir les Jalons',
    rewardsEarned: 'Votre Croissance',
    earned: 'Repondues',
    total: 'Total',
    toNextLevel: 'au prochain jalon',
    level: 'Parcours',
    youAreGettingStronger: 'Vous grandissez en connaissance',
    newAchievements: 'Nouveaux Jalons',
    dayStreak: 'jours avec les Écritures',
    days: 'jours',
    best: 'Meilleur',
    newPersonalBest: 'Nouveau record personnel',
    calculatingRewards: 'Reflexion sur votre parcours',
    retry: 'Réessayer',
    
    // Single Player Submitting Screen
    submittingYourResults: 'Envoi de vos résultats…',
    
    // Bible Verses
    verseFightGoodFight: '"J\'ai combattu le bon combat, j\'ai achevé la course, j\'ai gardé la foi." — 2 Timothée 4:7',
    verseSpurOneAnother: '"Veillons les uns sur les autres pour nous exciter à l\'amour et aux bonnes œuvres." — Hébreux 10:24',
    verseBeStrong: '"Fortifie-toi et prends courage, ne crains point et ne t\'effraie point, car l\'Éternel, ton Dieu, est avec toi partout où tu iras." — Josué 1:9',
    
    // Error Messages
    noUserAuthenticated: 'Utilisateur non authentifié - impossible de charger la gamification',
    authenticationError: 'Erreur d\'authentification - impossible de charger la gamification',
    missingQuizResults: 'Données de résultats du quiz manquantes',
    rewardCalculationTimeout: 'Le calcul des récompenses a expiré. Veuillez réessayer.',
    gamificationNotSetup: 'Système de gamification non configuré correctement',
    failedToLoadGamification: 'Échec du chargement des données de gamification',
    shareFailed: 'Échec du partage',
    noRoomIdAvailable: 'ID de salle non disponible.',
    errorLoadingResults: 'Erreur lors du chargement des résultats',
  },

  de: {
    savedToJourney: 'In deiner Reise gespeichert',
    backToGroupLobby: 'Zurück zur {{groupType}}-Lobby',
    categoryMasterySummary: 'Deine letzte Runde wurde zu {{category}} hinzugefügt.',
    chooseNextQuiz: 'Nächstes Quiz wählen',
    localGuestProgress: 'Melde dich an, wenn du bereit bist, diesen Fortschritt auf allen Geräten zu behalten.',
    startNewGroupQuiz: 'Neues {{groupType}}-Quiz starten',
    startNextGroupSubtitle: 'Starte eine neue Runde mit derselben {{groupType}}-Gruppe oder gehe zurück zur {{groupType}}-Lobby.',
    startNextGroupTitle: 'Noch ein {{groupType}}-Quiz spielen',
    storedOnDevice: 'Auf diesem Gerät gespeichert',
    waitForHostNextGroup: 'Sobald der Gastgeber ein weiteres Quiz startet, kehren alle automatisch in den Raum zurück.',
    waitingForNextGroupSubtitle: 'Der Gastgeber kann eine weitere Runde starten. Du kannst solange zur {{groupType}}-Lobby zurückkehren.',
    waitingForNextGroupTitle: 'Warten auf das nächste {{groupType}}-Quiz',
    // Common Results
    quizComplete: 'Quiz Abgeschlossen!',
    congratulations: 'Herzlichen Glückwunsch!',
    score: 'Punktzahl',
    accuracy: 'Genauigkeit',
    time: 'Zeit',
    playAgain: 'Nochmal Spielen',
    shareResults: 'Ergebnisse Teilen',
    home: 'Startseite',
    viewAll: 'Alle Anzeigen',
    moreAchievements: 'weitere Erfolge',
    
    // Single Player Results
    perfectScore: 'Perfekte Punktzahl!',
    excellentPerformance: 'Ausgezeichnete Leistung!',
    excellentWork: 'Ausgezeichnete Arbeit!',
    goodJob: 'Gute Arbeit!',
    keepPracticing: 'Weiter Üben!',
    keepLearning: 'Jede Frage ist ein weiterer Schritt zum Verständnis.',
    finalScore: 'Endpunktzahl',
    outOf: 'von',
    accuracyRate: 'Genauigkeitsrate',
    resultsSavedSuccessfully: 'Ergebnisse erfolgreich gespeichert',
    shareMessage: 'Ich habe {{score}}/{{total}} im Bibel-Quiz erreicht! Können Sie meine Punktzahl schlagen?',
    sessionComplete: 'Einheit abgeschlossen',
    reflectionSubtitle: 'Sie haben heute Zeit im Wort Gottes verbracht',
    questionsExplored: 'Fragen erkundet',
    fromCategory: 'Aus {{category}}',
    insightHighlight: 'Etwas, das Sie gelernt haben',
    comeBackTomorrow: 'Kommen Sie morgen wieder',
    tomorrowPrompt: 'Es gibt noch mehr zu entdecken',
    shareWithFamily: 'Mit Ihrer Familie teilen',
    continueJourney: 'Setzen Sie Ihre Reise fort',
    whatNext: 'Was kommt als Nächstes?',
    daysWithScripture: 'Tage mit der Schrift in diesem Monat',
    
    // Multiplayer Results
    youWon: '🏆 Sie haben Gewonnen!',
    itsATie: '🤝 Es ist Unentschieden!',
    gameOver: 'Spiel Vorbei',
    wellPlayedBoth: 'Gut gespielt ihr beiden!',
    betterLuckNextTime: 'Mehr Glück beim nächsten Mal!',
    wonTheGame: '{{name}} hat Gewonnen!',
    leaderboard: 'Bestenliste',
    place: 'Platz',
    player: 'Spieler',
    rematch: 'Revanche',
    newGame: 'Neues Spiel',
    multiplayerShareMessage: 'Ich habe {{score}} Punkte erreicht und Platz #{{place}} in einem Bibel-Trivia-Spiel belegt! 🏆\nMachen Sie beim nächsten Mal mit!',
    waitingForResults: 'Warte auf Ergebnisse...',
    fetchingResults: 'Ergebnisse werden abgerufen...',
    retryLoadResults: 'Wiederholen',
    noPlayersFound: 'Keine Spieler in diesem Spiel gefunden.',
    
    // Gamification
    xpEarned: 'Wachstum',
    levelUp: 'Neuer Meilenstein!',
    newRank: 'Neuer Meilenstein',
    achievements: 'Meilensteine',
    dailyStreak: 'Tage mit der Schrift',
    daysStreak: '{{count}} Tage',
    viewProgress: 'Ihre Reise Anzeigen',
    viewAchievements: 'Meilensteine Anzeigen',
    rewardsEarned: 'Ihr Wachstum',
    earned: 'Beantwortet',
    total: 'Gesamt',
    toNextLevel: 'zum nächsten Meilenstein',
    level: 'Reise',
    youAreGettingStronger: 'Sie wachsen im Wissen',
    newAchievements: 'Neue Meilensteine',
    dayStreak: 'Tage mit der Schrift',
    days: 'Tage',
    best: 'Beste',
    newPersonalBest: 'Neue Bestleistung',
    calculatingRewards: 'Über Ihre Reise nachdenken',
    retry: 'Wiederholen',
    
    // Single Player Submitting Screen
    submittingYourResults: 'Ihre Ergebnisse werden übermittelt…',
    
    // Bible Verses
    verseFightGoodFight: '"Ich habe den guten Kampf gekämpft, ich habe den Lauf vollendet, ich habe Glauben gehalten." — 2. Timotheus 4:7',
    verseSpurOneAnother: '"Lasst uns aufeinander achthaben und einander anspornen zur Liebe und zu guten Werken." — Hebräer 10:24',
    verseBeStrong: '"Sei mutig und stark! Fürchte dich nicht und hab keine Angst; denn der Herr, dein Gott, ist mit dir überall, wo du hingehst." — Josua 1:9',
    
    // Error Messages
    noUserAuthenticated: 'Benutzer nicht authentifiziert - Gamification kann nicht geladen werden',
    authenticationError: 'Authentifizierungsfehler - Gamification kann nicht geladen werden',
    missingQuizResults: 'Fehlende Quiz-Ergebnisdaten',
    rewardCalculationTimeout: 'Belohnungsberechnung abgelaufen. Bitte versuchen Sie es erneut.',
    gamificationNotSetup: 'Gamification-System nicht richtig konfiguriert',
    failedToLoadGamification: 'Fehler beim Laden der Gamification-Daten',
    shareFailed: 'Teilen fehlgeschlagen',
    noRoomIdAvailable: 'Keine Raum-ID verfügbar.',
    errorLoadingResults: 'Fehler beim Laden der Ergebnisse',
  },

  pt: {
    savedToJourney: 'Salvo na sua jornada',
    backToGroupLobby: 'Voltar ao lobby de {{groupType}}',
    categoryMasterySummary: 'Sua última sessão foi adicionada a {{category}}.',
    chooseNextQuiz: 'Escolher o próximo quiz',
    localGuestProgress: 'Entre quando quiser para manter este progresso em todos os seus dispositivos.',
    startNewGroupQuiz: 'Iniciar novo quiz de {{groupType}}',
    startNextGroupSubtitle: 'Inicie uma nova rodada com o mesmo grupo de {{groupType}} ou volte ao lobby de {{groupType}}.',
    startNextGroupTitle: 'Jogar outro quiz de {{groupType}}',
    storedOnDevice: 'Salvo neste dispositivo',
    waitForHostNextGroup: 'Quando o anfitrião iniciar outro quiz, todos voltarão à sala automaticamente.',
    waitingForNextGroupSubtitle: 'O anfitrião pode iniciar outra rodada. Você pode voltar ao lobby de {{groupType}} enquanto espera.',
    waitingForNextGroupTitle: 'Aguardando o próximo quiz de {{groupType}}',
    // Common Results
    quizComplete: 'Quiz Concluído!',
    congratulations: 'Parabéns!',
    score: 'Pontuação',
    accuracy: 'Precisão',
    time: 'Tempo',
    playAgain: 'Jogar Novamente',
    shareResults: 'Compartilhar Resultados',
    home: 'Início',
    viewAll: 'Ver Tudo',
    moreAchievements: 'mais conquistas',
    
    // Single Player Results
    perfectScore: 'Pontuação Perfeita!',
    excellentPerformance: 'Excelente Desempenho!',
    excellentWork: 'Excelente Trabalho!',
    goodJob: 'Bom Trabalho!',
    keepPracticing: 'Continue Praticando!',
    keepLearning: 'Cada pergunta é mais um passo rumo à compreensão.',
    finalScore: 'Pontuação Final',
    outOf: 'de',
    accuracyRate: 'Taxa de Precisão',
    resultsSavedSuccessfully: 'Resultados salvos com sucesso',
    shareMessage: 'Eu marquei {{score}}/{{total}} no Quiz Bíblico! Você pode superar minha pontuação?',
    sessionComplete: 'Sessão concluída',
    reflectionSubtitle: 'Hoje você passou tempo na Palavra de Deus',
    questionsExplored: 'perguntas exploradas',
    fromCategory: 'De {{category}}',
    insightHighlight: 'Algo que você aprendeu',
    comeBackTomorrow: 'Volte amanhã',
    tomorrowPrompt: 'Há mais para descobrir',
    shareWithFamily: 'Compartilhe com sua família',
    continueJourney: 'Continue sua jornada',
    whatNext: 'O que vem a seguir?',
    daysWithScripture: 'dias com as Escrituras neste mês',
    
    // Multiplayer Results
    youWon: '🏆 Você Ganhou!',
    itsATie: '🤝 É um Empate!',
    gameOver: 'Fim de Jogo',
    wellPlayedBoth: 'Bem jogado vocês dois!',
    betterLuckNextTime: 'Mais sorte na próxima vez!',
    wonTheGame: '{{name}} Ganhou!',
    leaderboard: 'Placar',
    place: 'Lugar',
    player: 'Jogador',
    rematch: 'Revanche',
    newGame: 'Novo Jogo',
    multiplayerShareMessage: 'Eu marquei {{score}} e fiquei em #{{place}} em uma partida de Trivia Bíblica! 🏆\nJunte-se a mim na próxima vez!',
    waitingForResults: 'Aguardando resultados...',
    fetchingResults: 'Buscando resultados...',
    retryLoadResults: 'Tentar Novamente',
    noPlayersFound: 'Nenhum jogador encontrado neste jogo.',
    
    // Gamification
    xpEarned: 'Crescimento',
    levelUp: 'Novo Marco!',
    newRank: 'Novo Marco',
    achievements: 'Marcos',
    dailyStreak: 'Dias com as Escrituras',
    daysStreak: '{{count}} dias',
    viewProgress: 'Ver Sua Jornada',
    viewAchievements: 'Ver Marcos',
    rewardsEarned: 'Seu Crescimento',
    earned: 'Respondidas',
    total: 'Total',
    toNextLevel: 'para o proximo marco',
    level: 'Jornada',
    youAreGettingStronger: 'Você esta crescendo em conhecimento',
    newAchievements: 'Novos Marcos',
    dayStreak: 'dias com as Escrituras',
    days: 'dias',
    best: 'Melhor',
    newPersonalBest: 'Novo recorde pessoal',
    calculatingRewards: 'Refletindo sobre sua jornada',
    retry: 'Tentar Novamente',
    
    // Single Player Submitting Screen
    submittingYourResults: 'Enviando seus resultados…',
    
    // Bible Verses
    verseFightGoodFight: '"Combati o bom combate, acabei a carreira, guardei a fé." — 2 Timóteo 4:7',
    verseSpurOneAnother: '"Consideremo-nos uns aos outros, para nos estimularmos ao amor e às boas obras." — Hebreus 10:24',
    verseBeStrong: '"Esforça-te e tem bom ânimo; não te atemorizes, nem te espantes, porque o Senhor, teu Deus, é contigo por onde quer que andares." — Josué 1:9',
    
    // Error Messages
    noUserAuthenticated: 'Usuário não autenticado - não é possível carregar gamificação',
    authenticationError: 'Erro de autenticação - não é possível carregar gamificação',
    missingQuizResults: 'Dados de resultados do quiz ausentes',
    rewardCalculationTimeout: 'Cálculo de recompensas expirou. Por favor, tente novamente.',
    gamificationNotSetup: 'Sistema de gamificação não configurado corretamente',
    failedToLoadGamification: 'Falha ao carregar dados de gamificação',
    shareFailed: 'Falha ao compartilhar',
    noRoomIdAvailable: 'ID da sala não disponível.',
    errorLoadingResults: 'Erro ao carregar resultados',
  },

  // Adding remaining 5 languages: ru, tl, it, am, ko
  ru: {
    savedToJourney: 'Сохранено в вашем пути',
    backToGroupLobby: 'Назад в лобби ({{groupType}})',
    categoryMasterySummary: 'Ваша последняя сессия добавлена в категорию «{{category}}».',
    chooseNextQuiz: 'Выбрать следующую викторину',
    localGuestProgress: 'Войдите, когда будете готовы, чтобы сохранить этот прогресс на всех устройствах.',
    startNewGroupQuiz: 'Начать новую викторину ({{groupType}})',
    startNextGroupSubtitle: 'Начните новый раунд с той же группой ({{groupType}}) или вернитесь в лобби ({{groupType}}).',
    startNextGroupTitle: 'Сыграть ещё одну викторину ({{groupType}})',
    storedOnDevice: 'Сохранено на этом устройстве',
    waitForHostNextGroup: 'Когда ведущий начнёт новую викторину, все автоматически вернутся в комнату.',
    waitingForNextGroupSubtitle: 'Ведущий может начать новый раунд. Пока ждёте, можно вернуться в лобби ({{groupType}}).',
    waitingForNextGroupTitle: 'Ожидание следующей викторины ({{groupType}})',
    // Common Results
    quizComplete: 'Викторина Завершена!',
    congratulations: 'Поздравляем!',
    score: 'Счет',
    accuracy: 'Точность',
    time: 'Время',
    playAgain: 'Играть Снова',
    shareResults: 'Поделиться Результатами',
    home: 'Главная',
    viewAll: 'Посмотреть Все',
    moreAchievements: 'больше достижений',
    
    // Single Player Results
    perfectScore: 'Идеальный Счет!',
    excellentPerformance: 'Отличная Производительность!',
    excellentWork: 'Отличная Работа!',
    goodJob: 'Хорошая Работа!',
    keepPracticing: 'Продолжайте Практиковаться!',
    keepLearning: 'Каждый вопрос — ещё один шаг к пониманию.',
    finalScore: 'Финальный Счет',
    outOf: 'из',
    accuracyRate: 'Уровень Точности',
    resultsSavedSuccessfully: 'Результаты успешно сохранены',
    shareMessage: 'Я набрал {{score}}/{{total}} в Библейской Викторине! Можете ли вы побить мой счет?',
    sessionComplete: 'Сессия завершена',
    reflectionSubtitle: 'Сегодня вы провели время в Слове Божьем',
    questionsExplored: 'вопросов изучено',
    fromCategory: 'Из {{category}}',
    insightHighlight: 'То, что вы узнали',
    comeBackTomorrow: 'Возвращайтесь завтра',
    tomorrowPrompt: 'Впереди еще больше открытий',
    shareWithFamily: 'Поделитесь с семьей',
    continueJourney: 'Продолжайте свой путь',
    whatNext: 'Что дальше?',
    daysWithScripture: 'дней с Писанием в этом месяце',
    
    // Multiplayer Results
    youWon: '🏆 Вы Победили!',
    itsATie: '🤝 Ничья!',
    gameOver: 'Игра Окончена',
    wellPlayedBoth: 'Хорошо сыграли оба!',
    betterLuckNextTime: 'Больше удачи в следующий раз!',
    wonTheGame: '{{name}} Победил!',
    leaderboard: 'Таблица Лидеров',
    place: 'Место',
    player: 'Игрок',
    rematch: 'Реванш',
    newGame: 'Новая Игра',
    multiplayerShareMessage: 'Я набрал {{score}} и занял #{{place}} место в Библейской Викторине! 🏆\nПрисоединяйтесь в следующий раз!',
    waitingForResults: 'Ожидание результатов...',
    fetchingResults: 'Получение результатов...',
    retryLoadResults: 'Повторить',
    noPlayersFound: 'Игроки не найдены в этой игре.',
    
    // Gamification
    xpEarned: 'Рост',
    levelUp: 'Новый Рубеж!',
    newRank: 'Новый Рубеж',
    achievements: 'Рубежи',
    dailyStreak: 'Дни с Писанием',
    daysStreak: '{{count}} дней',
    viewProgress: 'Посмотреть Ваш Путь',
    viewAchievements: 'Посмотреть Рубежи',
    rewardsEarned: 'Ваш Рост',
    earned: 'Отвечено',
    total: 'Общий',
    toNextLevel: 'до следующего рубежа',
    level: 'Путь',
    youAreGettingStronger: 'Вы растете в знании',
    newAchievements: 'Новые Рубежи',
    dayStreak: 'дни с Писанием',
    days: 'дни',
    best: 'Лучший',
    newPersonalBest: 'Новый личный рекорд',
    calculatingRewards: 'Размышляя о вашем пути',
    retry: 'Повторить',
    
    // Single Player Submitting Screen
    submittingYourResults: 'Отправка ваших результатов…',
    
    // Bible Verses
    verseFightGoodFight: '"Подвигом добрым я подвизался, течение совершил, веру сохранил." — 2 Тимофею 4:7',
    verseSpurOneAnother: '"Будем внимательны друг ко другу, поощряя к любви и добрым делам." — Евреям 10:24',
    verseBeStrong: '"Будь тверд и мужествен, не страшись и не ужасайся; ибо с тобою Господь Бог твой везде, куда ни пойдешь." — Иисус Навин 1:9',
    
    // Error Messages
    noUserAuthenticated: 'Пользователь не аутентифицирован - невозможно загрузить геймификацию',
    authenticationError: 'Ошибка аутентификации - невозможно загрузить геймификацию',
    missingQuizResults: 'Отсутствуют данные результатов викторины',
    rewardCalculationTimeout: 'Время расчета наград истекло. Пожалуйста, попробуйте еще раз.',
    gamificationNotSetup: 'Система геймификации не настроена правильно',
    failedToLoadGamification: 'Не удалось загрузить данные геймификации',
    shareFailed: 'Не удалось поделиться',
    noRoomIdAvailable: 'ID комнаты недоступен.',
    errorLoadingResults: 'Ошибка загрузки результатов',
  },

  tl: {
    savedToJourney: 'Nai-save sa iyong paglalakbay',
    backToGroupLobby: 'Bumalik sa lobby ng {{groupType}}',
    categoryMasterySummary: 'Naidagdag ang huli mong session sa {{category}}.',
    chooseNextQuiz: 'Piliin ang Susunod na Quiz',
    localGuestProgress: 'Mag-sign in kapag handa ka na para mapanatili ang progresong ito sa lahat ng device.',
    startNewGroupQuiz: 'Magsimula ng bagong quiz ng {{groupType}}',
    startNextGroupSubtitle: 'Magsimula ng bagong round kasama ang parehong grupo ng {{groupType}}, o bumalik sa lobby ng {{groupType}}.',
    startNextGroupTitle: 'Maglaro ng isa pang quiz ng {{groupType}}',
    storedOnDevice: 'Naka-save sa device na ito',
    waitForHostNextGroup: 'Kapag nagsimula ang host ng isa pang quiz, awtomatikong babalik ang lahat sa kuwarto.',
    waitingForNextGroupSubtitle: 'Maaaring magsimula ng isa pang round ang host. Maaari kang bumalik sa lobby ng {{groupType}} habang naghihintay.',
    waitingForNextGroupTitle: 'Naghihintay sa susunod na quiz ng {{groupType}}',
    // Common Results
    quizComplete: 'Tapos na ang Quiz!',
    congratulations: 'Binabati Kita!',
    score: 'Puntos',
    accuracy: 'Katumpakan',
    time: 'Oras',
    playAgain: 'Maglaro Muli',
    shareResults: 'Ibahagi ang mga Resulta',
    home: 'Tahanan',
    viewAll: 'Tingnan Lahat',
    moreAchievements: 'higit pang mga tagumpay',
    
    // Single Player Results
    perfectScore: 'Perpektong Puntos!',
    excellentPerformance: 'Napakahusay na Pagganap!',
    excellentWork: 'Napakagaling!',
    goodJob: 'Magandang Trabaho!',
    keepPracticing: 'Patuloy na Magsanay!',
    keepLearning: 'Ang bawat tanong ay isang hakbang tungo sa mas malalim na pag-unawa.',
    finalScore: 'Huling Puntos',
    outOf: 'sa',
    accuracyRate: 'Rate ng Katumpakan',
    resultsSavedSuccessfully: 'Matagumpay na na-save ang mga resulta',
    shareMessage: 'Nakakuha ako ng {{score}}/{{total}} sa Bible Quiz! Kaya mo bang talunin ang aking puntos?',
    sessionComplete: 'Tapos na ang sesyon',
    reflectionSubtitle: 'Naglaan ka ng oras sa Salita ng Diyos ngayon',
    questionsExplored: 'mga tanong na natuklasan',
    fromCategory: 'Mula sa {{category}}',
    insightHighlight: 'Isang bagay na natutunan mo',
    comeBackTomorrow: 'Bumalik bukas',
    tomorrowPrompt: 'May higit ka pang matutuklasan',
    shareWithFamily: 'Ibahagi sa inyong pamilya',
    continueJourney: 'Ipagpatuloy ang iyong paglalakbay',
    whatNext: 'Ano ang susunod?',
    daysWithScripture: 'mga araw na kasama ang Kasulatan ngayong buwan',
    
    // Multiplayer Results
    youWon: '🏆 Nanalo Ka!',
    itsATie: '🤝 Tabla!',
    gameOver: 'Tapos na ang Laro',
    wellPlayedBoth: 'Maganda ang laro ninyong dalawa!',
    betterLuckNextTime: 'Mas swerte sa susunod!',
    wonTheGame: 'Si {{name}} ang Nanalo!',
    leaderboard: 'Talaan ng mga Nangunguna',
    place: 'Pwesto',
    player: 'Manlalaro',
    rematch: 'Ulitin',
    newGame: 'Bagong Laro',
    multiplayerShareMessage: 'Nakakuha ako ng {{score}} at pumwesto sa #{{place}} sa Bible Trivia! 🏆\nSumali sa susunod!',
    waitingForResults: 'Naghihintay ng mga resulta...',
    fetchingResults: 'Kinukuha ang mga resulta...',
    retryLoadResults: 'Subukan Muli',
    noPlayersFound: 'Walang nahanap na manlalaro sa larong ito.',
    
    // Gamification
    xpEarned: 'Pag-unlad',
    levelUp: 'Bagong Milestone!',
    newRank: 'Bagong Milestone',
    achievements: 'Mga Milestone',
    dailyStreak: 'Mga Araw sa Kasulatan',
    daysStreak: '{{count}} araw',
    viewProgress: 'Tingnan ang Inyong Paglalakbay',
    viewAchievements: 'Tingnan ang mga Milestone',
    rewardsEarned: 'Inyong Pag-unlad',
    earned: 'Sinagot',
    total: 'Kabuuan',
    toNextLevel: 'sa susunod na milestone',
    level: 'Paglalakbay',
    youAreGettingStronger: 'Lumalaki ang inyong kaalaman',
    newAchievements: 'Mga Bagong Milestone',
    dayStreak: 'araw sa Kasulatan',
    days: 'mga araw',
    best: 'Pinakamahusay',
    newPersonalBest: 'Bagong personal na record',
    calculatingRewards: 'Pinagninilay-nilay ang inyong paglalakbay',
    retry: 'Subukan Muli',
    
    // Single Player Submitting Screen
    submittingYourResults: 'Ipinapadala ang inyong mga resulta…',
    
    // Bible Verses
    verseFightGoodFight: '"Nakipaglaban ako ng mabuting pakikipaglaban, natapos ko ang takbuhin, iningatan ko ang pananampalataya." — 2 Timoteo 4:7',
    verseSpurOneAnother: '"At tayo\'y mag-isip-isipan upang puksain sa pag-ibig at sa mabubuting gawa." — Hebreo 10:24',
    verseBeStrong: '"Magpakatatag ka at magpakatapang; huwag kang matakot o mawalan ng loob, sapagkat kasama mo ang Panginoong iyong Diyos saan ka man pumunta." — Josue 1:9',
    
    // Error Messages
    noUserAuthenticated: 'Hindi nakapatunay ang user - hindi mai-load ang gamification',
    authenticationError: 'Error sa pagpapatunay - hindi mai-load ang gamification',
    missingQuizResults: 'Nawawalang datos ng resulta ng quiz',
    rewardCalculationTimeout: 'Nag-timeout ang pagkalkula ng gantimpala. Pakisubukan muli.',
    gamificationNotSetup: 'Hindi maayos na naka-configure ang sistema ng gamification',
    failedToLoadGamification: 'Nabigo sa pag-load ng gamification data',
    shareFailed: 'Nabigo ang pagbahagi',
    noRoomIdAvailable: 'Walang available na room ID.',
    errorLoadingResults: 'Error sa pag-load ng mga resulta',
  },

  it: {
    savedToJourney: 'Salvato nel tuo percorso',
    backToGroupLobby: 'Torna alla lobby {{groupType}}',
    categoryMasterySummary: 'La tua ultima sessione è stata aggiunta a {{category}}.',
    chooseNextQuiz: 'Scegli il prossimo quiz',
    localGuestProgress: 'Accedi quando vuoi per mantenere questi progressi su tutti i dispositivi.',
    startNewGroupQuiz: 'Avvia un nuovo quiz {{groupType}}',
    startNextGroupSubtitle: 'Avvia un nuovo round con lo stesso gruppo {{groupType}} oppure torna alla lobby {{groupType}}.',
    startNextGroupTitle: 'Gioca un altro quiz {{groupType}}',
    storedOnDevice: 'Salvato su questo dispositivo',
    waitForHostNextGroup: 'Quando l\'host avvierà un altro quiz, tutti torneranno automaticamente nella stanza.',
    waitingForNextGroupSubtitle: 'L\'host può avviare un altro round. Nel frattempo puoi tornare alla lobby {{groupType}}.',
    waitingForNextGroupTitle: 'In attesa del prossimo quiz {{groupType}}',
    // Common Results
    quizComplete: 'Quiz Completato!',
    congratulations: 'Congratulazioni!',
    score: 'Punteggio',
    accuracy: 'Precisione',
    time: 'Tempo',
    playAgain: 'Gioca Ancora',
    shareResults: 'Condividi Risultati',
    home: 'Home',
    viewAll: 'Vedi Tutto',
    moreAchievements: 'altri traguardi',
    
    // Single Player Results
    perfectScore: 'Punteggio Perfetto!',
    excellentPerformance: 'Prestazione Eccellente!',
    excellentWork: 'Ottimo Lavoro!',
    goodJob: 'Buon Lavoro!',
    keepPracticing: 'Continua a Praticare!',
    keepLearning: 'Ogni domanda è un passo in più verso la comprensione.',
    finalScore: 'Punteggio Finale',
    outOf: 'su',
    accuracyRate: 'Tasso di Precisione',
    resultsSavedSuccessfully: 'Risultati salvati con successo',
    shareMessage: 'Ho ottenuto {{score}}/{{total}} nel Quiz Biblico! Puoi battere il mio punteggio?',
    sessionComplete: 'Sessione completata',
    reflectionSubtitle: 'Oggi hai trascorso del tempo nella Parola di Dio',
    questionsExplored: 'domande esplorate',
    fromCategory: 'Da {{category}}',
    insightHighlight: 'Qualcosa che hai imparato',
    comeBackTomorrow: 'Torna domani',
    tomorrowPrompt: 'C\'è ancora altro da scoprire',
    shareWithFamily: 'Condividi con la tua famiglia',
    continueJourney: 'Continua il tuo cammino',
    whatNext: 'E adesso?',
    daysWithScripture: 'giorni con la Scrittura questo mese',
    
    // Multiplayer Results
    youWon: '🏆 Hai Vinto!',
    itsATie: '🤝 È un Pareggio!',
    gameOver: 'Gioco Finito',
    wellPlayedBoth: 'Ben giocato entrambi!',
    betterLuckNextTime: 'Più fortuna la prossima volta!',
    wonTheGame: '{{name}} ha Vinto!',
    leaderboard: 'Classifica',
    place: 'Posto',
    player: 'Giocatore',
    rematch: 'Rivincita',
    newGame: 'Nuovo Gioco',
    multiplayerShareMessage: 'Ho segnato {{score}} e mi sono piazzato #{{place}} in una partita di Trivia Biblica! 🏆\nUnisciti la prossima volta!',
    waitingForResults: 'In attesa dei risultati...',
    fetchingResults: 'Recupero risultati...',
    retryLoadResults: 'Riprova',
    noPlayersFound: 'Nessun giocatore trovato in questo gioco.',
    
    // Gamification
    xpEarned: 'Crescita',
    levelUp: 'Nuovo Traguardo!',
    newRank: 'Nuovo Traguardo',
    achievements: 'Traguardi',
    dailyStreak: 'Giorni con le Scritture',
    daysStreak: '{{count}} giorni',
    viewProgress: 'Vedi il Tuo Percorso',
    viewAchievements: 'Vedi i Traguardi',
    rewardsEarned: 'La Tua Crescita',
    earned: 'Risposte',
    total: 'Totale',
    toNextLevel: 'al prossimo traguardo',
    level: 'Percorso',
    youAreGettingStronger: 'Stai crescendo nella conoscenza',
    newAchievements: 'Nuovi Traguardi',
    dayStreak: 'giorni con le Scritture',
    days: 'giorni',
    best: 'Migliore',
    newPersonalBest: 'Nuovo record personale',
    calculatingRewards: 'Riflettendo sul tuo percorso',
    retry: 'Riprova',
    
    // Single Player Submitting Screen
    submittingYourResults: 'Invio dei tuoi risultati…',
    
    // Bible Verses
    verseFightGoodFight: '"Ho combattuto la buona battaglia, ho finito la corsa, ho conservato la fede." — 2 Timoteo 4:7',
    verseSpurOneAnother: '"Facciamo attenzione gli uni agli altri per incitarci all\'amore e alle buone opere." — Ebrei 10:24',
    verseBeStrong: '"Sii forte e coraggioso; non temere e non ti spaventare, perché il Signore, il tuo Dio, sarà con te dovunque tu vada." — Giosuè 1:9',
    
    // Error Messages
    noUserAuthenticated: 'Utente non autenticato - impossibile caricare la gamification',
    authenticationError: 'Errore di autenticazione - impossibile caricare la gamification',
    missingQuizResults: 'Dati dei risultati del quiz mancanti',
    rewardCalculationTimeout: 'Calcolo ricompense scaduto. Per favore riprova.',
    gamificationNotSetup: 'Sistema di gamification non configurato correttamente',
    failedToLoadGamification: 'Impossibile caricare i dati di gamification',
    shareFailed: 'Condivisione fallita',
    noRoomIdAvailable: 'ID stanza non disponibile.',
    errorLoadingResults: 'Errore nel caricamento dei risultati',
  },

  am: {
    savedToJourney: 'በጉዞዎ ውስጥ ተቀምጧል',
    backToGroupLobby: 'ወደ {{groupType}} ሎቢ ተመለስ',
    categoryMasterySummary: 'የመጨረሻው ክፍለ ጊዜዎ ወደ {{category}} ተጨምሯል።',
    chooseNextQuiz: 'ቀጣዩን ጥያቄ ይምረጡ',
    localGuestProgress: 'ይህን እድገት በሁሉም መሣሪያዎች ለማቆየት ዝግጁ ሲሆኑ ይግቡ።',
    startNewGroupQuiz: 'አዲስ የ{{groupType}} ጥያቄ ጀምር',
    startNextGroupSubtitle: 'ከተመሳሳይ የ{{groupType}} ቡድን ጋር አዲስ ዙር ይጀምሩ፣ ወይም ወደ {{groupType}} ሎቢ ይመለሱ።',
    startNextGroupTitle: 'ሌላ የ{{groupType}} ጥያቄ ይጫወቱ',
    storedOnDevice: 'በዚህ መሣሪያ ላይ ተቀምጧል',
    waitForHostNextGroup: 'አስተናጋጁ ሌላ ጥያቄ ሲጀምር ሁሉም በራስ-ሰር ወደ ክፍሉ ይመለሳሉ።',
    waitingForNextGroupSubtitle: 'አስተናጋጁ ሌላ ዙር ሊጀምር ይችላል። በሚጠብቁበት ጊዜ ወደ {{groupType}} ሎቢ መመለስ ይችላሉ።',
    waitingForNextGroupTitle: 'የሚቀጥለውን የ{{groupType}} ጥያቄ በመጠበቅ ላይ',
    // Common Results
    quizComplete: 'ጥያቄው ተጠናቅቋል!',
    congratulations: 'እንኳን ደስ አለዎት!',
    score: 'ውጤት',
    accuracy: 'ትክክለኛነት',
    time: 'ጊዜ',
    playAgain: 'እንደገና ተጫወት',
    shareResults: 'ውጤቶችን አጋራ',
    home: 'መነሻ',
    viewAll: 'ሁሉንም ይመልከቱ',
    moreAchievements: 'ተጨማሪ ስኬቶች',
    
    // Single Player Results
    perfectScore: 'ፍጹም ውጤት!',
    excellentPerformance: 'እጅግ በጣም ጥሩ አፈጻጸም!',
    excellentWork: 'እጅግ በጣም ጥሩ ስራ!',
    goodJob: 'ጥሩ ስራ!',
    keepPracticing: 'መለማመዱን ቀጥሉ!',
    keepLearning: 'እያንዳንዱ ጥያቄ ወደ መረዳት የሚያቀርብ አንድ እርምጃ ነው።',
    finalScore: 'የመጨረሻ ውጤት',
    outOf: 'ከ',
    accuracyRate: 'የትክክለኛነት መጠን',
    resultsSavedSuccessfully: 'ውጤቶች በተሳካ ሁኔታ ተቀምጠዋል',
    shareMessage: 'በመጽሐፍ ቅዱስ ጥያቄ {{score}}/{{total}} አግኝቻለሁ! የእኔን ውጤት መምታት ይችላሉ?',
    sessionComplete: 'ክፍለ ጊዜው ተጠናቋል',
    reflectionSubtitle: 'ዛሬ በእግዚአብሔር ቃል ውስጥ ጊዜ አሳልፈዋል',
    questionsExplored: 'የተመረመሩ ጥያቄዎች',
    fromCategory: 'ከ{{category}}',
    insightHighlight: 'የተማሩት አንድ ነገር',
    comeBackTomorrow: 'ነገ ተመለሱ',
    tomorrowPrompt: 'ከዚህ በላይ የሚገኝ አለ',
    shareWithFamily: 'ከቤተሰብዎ ጋር ያጋሩ',
    continueJourney: 'ጉዞዎን ይቀጥሉ',
    whatNext: 'ቀጣይ ምንድን ነው?',
    daysWithScripture: 'በዚህ ወር ከመጽሐፍ ቅዱስ ጋር ያሉ ቀናት',
    
    // Multiplayer Results
    youWon: '🏆 አሸንፈዋል!',
    itsATie: '🤝 አቻ ነው!',
    gameOver: 'ጨዋታው አለቀ',
    wellPlayedBoth: 'ሁለታችሁም በጥሩ ሁኔታ ተጫውታችኋል!',
    betterLuckNextTime: 'በሚቀጥለው ጊዜ የተሻለ ዕድል!',
    wonTheGame: '{{name}} አሸነፈ!',
    leaderboard: 'የመሪዎች ሰሌዳ',
    place: 'ቦታ',
    player: 'ተጫዋች',
    rematch: 'እንደገና መጫወት',
    newGame: 'አዲስ ጨዋታ',
    multiplayerShareMessage: '{{score}} አስመዝግቤ በመጽሐፍ ቅዱስ ጥያቄ ውድድር #{{place}} ቦታ ያዝኩ! 🏆\nበሚቀጥለው ጊዜ ይቀላቀሉ!',
    waitingForResults: 'ውጤቶችን በመጠበቅ ላይ...',
    fetchingResults: 'ውጤቶችን በማግኘት ላይ...',
    retryLoadResults: 'እንደገና ሞክር',
    noPlayersFound: 'በዚህ ጨዋታ ውስጥ ተጫዋቾች አልተገኙም።',
    
    // Gamification
    xpEarned: 'እድገት',
    levelUp: 'አዲስ ግብ!',
    newRank: 'አዲስ ግብ',
    achievements: 'ግቦች',
    dailyStreak: 'ከመጽሐፍ ቅዱስ ጋር ቀናት',
    daysStreak: '{{count}} ቀናት',
    viewProgress: 'ጉዞዎን ይመልከቱ',
    viewAchievements: 'ግቦችን ይመልከቱ',
    rewardsEarned: 'የእርስዎ እድገት',
    earned: 'ተመልሷል',
    total: 'ጠቅላላ',
    toNextLevel: 'ወደ ቀጣዩ ግብ',
    level: 'ጉዞ',
    youAreGettingStronger: 'በእውቀት እያደጉ ነው',
    newAchievements: 'አዲስ ግቦች',
    dayStreak: 'ከመጽሐፍ ቅዱስ ጋር ቀናት',
    days: 'ቀናት',
    best: 'ምርጥ',
    newPersonalBest: 'አዲስ የግል ምርጥ ውጤት',
    calculatingRewards: 'ስለ ጉዞዎ በማሰላሰል ላይ',
    retry: 'እንደገና ሞክር',
    
    // Single Player Submitting Screen
    submittingYourResults: 'ውጤቶችዎን በመላክ ላይ…',
    
    // Bible Verses
    verseFightGoodFight: '"መልካሙን ገድል ተጋድያለሁ፤ ሩጫዬን ጨርሻለሁ፤ ሃይማኖቴን ጠብቄአለሁ።" — 2 ጢሞቴዎስ 4:7',
    verseSpurOneAnother: '"እንዴት ለፍቅር ለመልካምም ሥራ እንደምንቀስቅሰው እርስ በርሳችን እናስብ።" — ዕብራውያን 10:24',
    verseBeStrong: '"ጽና፤ አይዞህ፤ አትፍራ፤ አትደንግጥ፤ የምትሄድበት ሁሉ አምላክህ እግዚአብሔር ከአንተ ጋር ነውና።" — ኢያሱ 1:9',
    
    // Error Messages
    noUserAuthenticated: 'ተጠቃሚ አልተረጋገጠም - ጌሚፊኬሽን መጫን አይቻልም',
    authenticationError: 'የማረጋገጫ ስህተት - ጌሚፊኬሽን መጫን አይቻልም',
    missingQuizResults: 'የጥያቄ ውጤት ውሂብ ይጎድላል',
    rewardCalculationTimeout: 'የሽልማት ስሌት ጊዜው አለቀ። እባክዎ እንደገና ይሞክሩ።',
    gamificationNotSetup: 'የጌሚፊኬሽን ስርዓት በትክክል አልተዋቀረም',
    failedToLoadGamification: 'የጌሚፊኬሽን ውሂብ መጫን አልተሳካም',
    shareFailed: 'ማጋራት አልተሳካም',
    noRoomIdAvailable: 'የክፍል መታወቂያ የለም።',
    errorLoadingResults: 'ውጤቶችን በመጫን ላይ ስህተት',
  },

  ko: {
    savedToJourney: '내 여정에 저장됨',
    backToGroupLobby: '{{groupType}} 로비로 돌아가기',
    categoryMasterySummary: '마지막 세션이 {{category}}에 추가되었습니다.',
    chooseNextQuiz: '다음 퀴즈 선택',
    localGuestProgress: '준비되면 로그인하여 이 진행 상황을 모든 기기에서 유지하세요.',
    startNewGroupQuiz: '새 {{groupType}} 퀴즈 시작',
    startNextGroupSubtitle: '같은 {{groupType}} 그룹으로 새 라운드를 시작하거나 {{groupType}} 로비로 돌아가세요.',
    startNextGroupTitle: '{{groupType}} 퀴즈 한 번 더 하기',
    storedOnDevice: '이 기기에 저장됨',
    waitForHostNextGroup: '호스트가 다른 퀴즈를 시작하면 모두 자동으로 방으로 돌아갑니다.',
    waitingForNextGroupSubtitle: '호스트가 다른 라운드를 시작할 수 있습니다. 기다리는 동안 {{groupType}} 로비로 돌아갈 수 있습니다.',
    waitingForNextGroupTitle: '다음 {{groupType}} 퀴즈를 기다리는 중',
    // Common Results
    quizComplete: '퀴즈 완료!',
    congratulations: '축하합니다!',
    score: '점수',
    accuracy: '정확도',
    time: '시간',
    playAgain: '다시 플레이',
    shareResults: '결과 공유',
    home: '홈',
    viewAll: '모두 보기',
    moreAchievements: '더 많은 업적',
    
    // Single Player Results
    perfectScore: '완벽한 점수!',
    excellentPerformance: '뛰어난 성과!',
    excellentWork: '훌륭한 작업!',
    goodJob: '잘했어요!',
    keepPracticing: '계속 연습하세요!',
    keepLearning: '모든 질문은 이해에 한 걸음 더 가까워지는 과정입니다.',
    finalScore: '최종 점수',
    outOf: '중',
    accuracyRate: '정확도율',
    resultsSavedSuccessfully: '결과가 성공적으로 저장되었습니다',
    shareMessage: '성경 퀴즈에서 {{score}}/{{total}}점을 받았습니다! 내 점수를 이길 수 있나요?',
    sessionComplete: '세션 완료',
    reflectionSubtitle: '오늘 하나님의 말씀 안에서 시간을 보냈습니다',
    questionsExplored: '살펴본 질문',
    fromCategory: '{{category}}에서',
    insightHighlight: '오늘 배운 한 가지',
    comeBackTomorrow: '내일 다시 오세요',
    tomorrowPrompt: '아직 더 발견할 것이 있습니다',
    shareWithFamily: '가족과 함께 나누기',
    continueJourney: '여정을 계속하세요',
    whatNext: '다음은 무엇인가요?',
    daysWithScripture: '이번 달 말씀과 함께한 날',
    
    // Multiplayer Results
    youWon: '🏆 승리하셨습니다!',
    itsATie: '🤝 무승부입니다!',
    gameOver: '게임 종료',
    wellPlayedBoth: '두 분 모두 잘 플레이하셨습니다!',
    betterLuckNextTime: '다음에는 더 행운이 있기를!',
    wonTheGame: '{{name}}님이 승리했습니다!',
    leaderboard: '리더보드',
    place: '순위',
    player: '플레이어',
    rematch: '재경기',
    newGame: '새 게임',
    multiplayerShareMessage: '성경 퀴즈에서 {{score}}점을 얻어 #{{place}}위를 했습니다! 🏆\n다음에 함께해요!',
    waitingForResults: '결과 대기 중...',
    fetchingResults: '결과 가져오는 중...',
    retryLoadResults: '다시 시도',
    noPlayersFound: '이 게임에서 플레이어를 찾을 수 없습니다.',
    
    // Gamification
    xpEarned: '성장',
    levelUp: '새로운 이정표!',
    newRank: '새로운 이정표',
    achievements: '이정표',
    dailyStreak: '성경과 함께한 날',
    daysStreak: '{{count}}일',
    viewProgress: '여정 보기',
    viewAchievements: '이정표 보기',
    rewardsEarned: '나의 성장',
    earned: '답변',
    total: '총합',
    toNextLevel: '다음 이정표까지',
    level: '여정',
    youAreGettingStronger: '지식이 자라고 있습니다',
    newAchievements: '새로운 이정표',
    dayStreak: '성경과 함께한 날',
    days: '일',
    best: '최고',
    newPersonalBest: '새로운 개인 기록',
    calculatingRewards: '여정을 돌아보는 중',
    retry: '다시 시도',
    
    // Single Player Submitting Screen
    submittingYourResults: '결과를 제출하는 중…',
    
    // Bible Verses
    verseFightGoodFight: '"나는 선한 싸움을 싸우고 나의 달려갈 길을 마치고 믿음을 지켰으니" — 디모데후서 4:7',
    verseSpurOneAnother: '"서로 돌아보아 사랑과 선행을 격려하며" — 히브리서 10:24',
    verseBeStrong: '"강하고 담대하라 두려워하지 말며 놀라지 말라 네가 어디로 가든지 네 하나님 여호와가 너와 함께 하느니라" — 여호수아 1:9',
    
    // Error Messages
    noUserAuthenticated: '사용자 인증 안됨 - 게임화를 로드할 수 없습니다',
    authenticationError: '인증 오류 - 게임화를 로드할 수 없습니다',
    missingQuizResults: '퀴즈 결과 데이터 누락',
    rewardCalculationTimeout: '보상 계산 시간 초과. 다시 시도해 주세요.',
    gamificationNotSetup: '게임화 시스템이 올바르게 구성되지 않음',
    failedToLoadGamification: '게임화 데이터 로드 실패',
    shareFailed: '공유 실패',
    noRoomIdAvailable: '사용 가능한 방 ID가 없습니다.',
    errorLoadingResults: '결과 로드 중 오류',
  },
};
